export default "__VITE_ASSET__48f1b9f9__"